<template>
  <van-popup v-model="show" position="right">
    <div class="capture-page">
      <!--video用于显示媒体设备的视频流，自动播放-->
      <video
        id="video"
        autoplay
        ref="videoComp"
        class="video-ctn"
        :style="{width:cw+'px',height:ch+'px'}"
        v-show="!isShowCanvas"
      ></video>
      <!--拍照按钮-->
      <div>
        <take-pic @click.native="capture" v-show="!isShowCanvas"></take-pic>
      </div>
      <div class="btn-group" v-show="isShowCanvas">
        <van-icon name="close" :size="size" color="#3cb8a2" @click="handleClose"/>
        <van-icon name="passed" :size="size" color="#3cb8a2" @click="handlePass"/>
      </div>
      <!--描绘video截图-->
      <canvas
        id="canvas"
        :width="cw"
        :height="ch"
        ref="canvas"
        class="canvas-ctn"
        v-show="isShowCanvas"
      ></canvas>
    </div>
  </van-popup>
</template>

<script>
import TakePic from "@/components/TakePic";
export default {
  name: "capture",
  props: {
    showCapture: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: function() {
      return this.showCapture;
    }
  },
  data() {
    return {
      canvas: null,
      constrains: {
        video: {
          widht: 480,
          height: 320,
          facingMode: { exact: "environment" } // 后置摄像头
        },
        audio: false
      },
      size: "50px",
      video: null,
      context: null,
      cw: null,
      ch: null,
      isShowCanvas: false,
      img: null
    };
  },
  mounted() {
    // this.cw = document.body.clientWidth;
    // this.ch = document.body.clientHeight;
    // this.video = document.getElementById("video");
    // this.canvas = this.$refs.canvas;
    // this.context = this.canvas.getContext("2d");
    if (
      navigator.mediaDevices.getUserMedia ||
      navigator.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia
    ) {
      //调用用户媒体设备，访问摄像头
      this.getUserMedia(this.constrains, this.success, this.error);
    } else {
      alert("你的浏览器不支持访问用户媒体设备");
    }
  },
  components: {
    TakePic
  },
  methods: {
    capture() {
      // 拍照
      this.context.drawImage(this.video, 0, 0, this.cw, this.ch);
      this.img = this.canvas.toDataURL("image/png");
      this.isShowCanvas = true;
    },
    getUserMedia(constrains, success, error) {
      //访问用户媒体设备的兼容方法
      if (navigator.mediaDevices.getUserMedia) {
        //最新标准API
        navigator.mediaDevices
          .getUserMedia(constrains)
          .then(success)
          .catch(error);
      } else if (navigator.webkitGetUserMedia) {
        //webkit内核浏览器
        navigator
          .webkitGetUserMedia(constrains)
          .then(success)
          .catch(error);
      } else if (navigator.mozGetUserMedia) {
        //Firefox浏览器
        navagator
          .mozGetUserMedia(constrains)
          .then(success)
          .catch(error);
      } else if (navigator.getUserMedia) {
        //旧版API
        navigator
          .getUserMedia(constrains)
          .then(success)
          .catch(error);
      }
    },
    success(stream) {
      //兼容webkit内核浏览器
      var CompatibleURL = window.URL || window.webkitURL;
      //将视频流设置为video元素的源
      this.video.src = CompatibleURL.createObjectURL(stream);
      //播放视频
      this.video.play();
    },
    error(error) {
      console.log("访问用户媒体设备失败：", error.name, error.message);
    },
    handleClose() {
      this.isShowCanvas = false;
    },
    handlePass() {
      alert("成功");
      localStorage.setItem("szImg", this.img);
      this.isShowCanvas = false;
      this.$router.push("/collect/add");
    }
  }
};
</script>
<style lang="scss" scoped>
.capture-page {
  position: relative;
  height: 100vh;
  .video-ctn {
    position: absolute;
  }
  .take-pic {
    left: 50%;
    right: auto !important;
    transform: translateX(-50%) !important;
  }
  .canvas-ctn {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
  }
  .btn-group {
    display: flex;
    width: 80%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    margin: auto;
    justify-content: space-between;
    position: fixed;
    z-index: 9999;
    bottom: 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/base/capture.vue